import { Formik } from "formik";

import { useGetSoftwareLicenceByIdQuery, useUpdateSoftwareLicenceMutation } from "@sso/apis/softwareLicences";
import FormikEditor from "@sso/components/Formik/FormikEditor";
import { useAppSelector } from "@sso/hooks/useRedux";
import { selectDialog } from "@sso/store/slices/dialog";
import { SoftwareLicenceUpdateRequest } from "@sso/types";
import { CustomForm } from "@sso/ui/CustomForm";

import { DialogActionButtons, DialogBody, DialogHeader } from "../../components";

const EditLicenceType = () => {
  const { id } = useAppSelector(selectDialog);

  if (!id) {
    throw new Error("LicenceEditDialog: id is null");
  }
  const { data, isSuccess } = useGetSoftwareLicenceByIdQuery(id);
  const [updateSoftwareLicence, { isLoading: updateLoading }] = useUpdateSoftwareLicenceMutation();

  const request: SoftwareLicenceUpdateRequest = {
    softwareLicenceId: id.toString(),
    featureHtml: data?.featureHtml,
  };

  const handleSubmit = (values: SoftwareLicenceUpdateRequest) => {
    updateSoftwareLicence(values);
  };

  return (
    <>
      {data && isSuccess && (
        <Formik onSubmit={handleSubmit} initialValues={request} enableReinitialize>
          {() => (
            <CustomForm padding="1rem 0" width="100%" overflow="hidden">
              <DialogBody>
                <FormikEditor value={data.featureHtml} label="Feature Text" name="featureHtml" />
              </DialogBody>
              <DialogActionButtons loading={updateLoading} buttonTitle={"Edit"} />
            </CustomForm>
          )}
        </Formik>
      )}
    </>
  );
};

export default EditLicenceType;
